'use strict';

angular.module('clientDashboardApp').controller("MyAccountCtrl",
    function MyAccountCtrl($scope, $location, Upload, userService, configService) {

      $scope.currentStep = 0;

      $scope.openLogoUploadModal = function(){
        $('#uploadLogoModal').modal();
      }

      // upload later on form submit or something similar
      $scope.submit = function() {
        if ($scope.form.file.$valid && $scope.file) {
          $scope.upload($scope.file);
        }
      };

      $scope.updateCurrentStep = function(step){
        $scope.currentStep = step;
      }

      userService.currentUser(true).then(function(user){
        $scope.userId = user.userId;
        $scope.userInfo = user;
      });

      // upload on file select or drop
      $scope.upload = function (files) {
        if (files && files.length) {
          $scope.updateCurrentStep(2);

          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            $scope.uploadProgress = 0;
            $scope.fileUploading = file.name;

            Upload.upload({
              url: '/admin/logo/upload',
              file: file
            }).progress(function (evt) {
              var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
              $scope.uploadProgress = progressPercentage;
            }).success(function (data, status, headers, config) {
              $scope.uploadComplete = true;
              //startImport(data);
            }).error(function (data, status, headers, config) {
              $scope.failedUpload = true;
              //showFailedError({message: "Problem uploading file: " + data});
            });

          }
        }
      };


    });
